import { Pipe, PipeTransform } from '@angular/core';

/** Entités nommées rencontrées dans les contenus rédigés (CMS). */
const NAMED_ENTITIES: Record<string, string> = {
	amp: '&',
	lt: '<',
	gt: '>',
	quot: '"',
	apos: "'",
	nbsp: ' ',
	eacute: 'é', egrave: 'è', ecirc: 'ê', euml: 'ë',
	agrave: 'à', acirc: 'â', ccedil: 'ç',
	ugrave: 'ù', ucirc: 'û', uuml: 'ü',
	icirc: 'î', iuml: 'ï',
	ocirc: 'ô', ouml: 'ö',
	laquo: '«', raquo: '»',
	hellip: '…', ndash: '–', mdash: '—',
	rsquo: '’', lsquo: '‘',
	ldquo: '“', rdquo: '”',
	euro: '€', deg: '°',
};

@Pipe({ name: 'decodeHtml' })
export class DecodeHtmlPipe implements PipeTransform {
	/**
	 * Décodage par manipulation de chaîne, et non via `document.createElement` :
	 * les pipes sont évalués pendant le rendu SSR, où `document` n'existe pas. Une seule
	 * implémentation pour le serveur et le navigateur évite aussi tout écart à l'hydratation.
	 */
	transform(value: string): string {
		if (!value) return '';

		return value.replace(/&(#[0-9]+|#[xX][0-9a-fA-F]+|[a-zA-Z][a-zA-Z0-9]*);/g, (match, entity: string) => {
			if (entity[0] === '#') {
				const isHex = entity[1] === 'x' || entity[1] === 'X';
				const code = parseInt(isHex ? entity.slice(2) : entity.slice(1), isHex ? 16 : 10);
				return Number.isFinite(code) && code > 0 ? String.fromCodePoint(code) : match;
			}
			return NAMED_ENTITIES[entity.toLowerCase()] ?? match;
		});
	}
}
